import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { maxChildLevelForChartOfAccountsView } from 'src/app/finance/constants/constants';
import { FinanceUtilityService } from 'src/app/finance/util/finance-utility.service';

@Component({
  selector: 'app-finance-transaction-availability-modal',
  templateUrl: './finance-transaction-availability-modal.component.html',
  styleUrls: ['./finance-transaction-availability-modal.component.scss']
})
export class FinanceTransactionAvailabilityModalComponent implements OnInit {

  @Input() displayTransactionAvailability;
  @Input() associatedTransactions;
  @Input() account;
  @Output() onAccountSelectAndSave = new EventEmitter();
  @Output() onCloseDialog = new EventEmitter();

  accountTypes = [];
  selectedAccount;

  constructor(private financeUtilityService: FinanceUtilityService) { }

  ngOnInit(): void {
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.account && changes.account.currentValue) {
        this.account = changes.account.currentValue;
        // console.log(this.account);
        this.accountTypes = this.financeUtilityService.getAccountTypes(true,true,[this.account], false, 1, maxChildLevelForChartOfAccountsView);
        this.selectedAccount = null;
    }
  }

  save(){
    // console.log(this.selectedAccount);
    this.onAccountSelectAndSave.emit(this.selectedAccount.value.id);
  }

  closeDialog(){
    this.onCloseDialog.emit({});
  }
}
